import { DEALER_PASSPORT_OPTION_STATUS } from "~/components/Forms/DealerPassportForm/options";
import { FilterField } from "~/features/filter";

import {
  useCityOptions,
  useCountryOptions,
  useFederalAreaOptions,
  useSubjectOptions,
} from "./optionsHooks";

type Translate = (key: string) => string;

/**
 * Поля фильтра страницы дилеров. Имена полей совпадают с именами полей
 * старого DealersFilter — они же ключи query-переменных поиска дилеров.
 * Раскладка — три строки, как в старой форме: 5 полей, 5 полей, 2 поля.
 */
export const dealersFilterFields = (t: Translate): FilterField[] => {
  const firstRow: FilterField[] = [
    {
      name: "id",
      type: "input",
      label: t("dealers.id"),
    },
    {
      name: "DealerName",
      type: "input",
      label: t("dealers.DealerName"),
    },
    {
      name: "INN",
      type: "input",
      label: t("dealers.INN"),
    },
    {
      name: "status",
      type: "select",
      label: t("dealers.status"),
      placeholder: t("common.not_selected"),
      options: DEALER_PASSPORT_OPTION_STATUS.map((value) => ({
        value,
        label: t(`dealersForm.${value}`),
      })),
    },
    {
      name: "birCode",
      type: "input",
      label: t("dealers.birCode"),
    },
  ];

  const secondRow: FilterField[] = [
    {
      name: "country",
      type: "select",
      label: t("dealers.country"),
      placeholder: t("common.not_selected"),
      optionsHook: useCountryOptions,
    },
    {
      name: "FO",
      type: "select",
      label: t("dealers.FO"),
      placeholder: t("common.not_selected"),
      optionsHook: useFederalAreaOptions,
    },
    {
      name: "subject",
      type: "select",
      label: t("dealers.subject"),
      placeholder: t("common.not_selected"),
      optionsHook: useSubjectOptions,
    },
    {
      name: "city",
      type: "select",
      label: t("dealers.city"),
      placeholder: t("common.not_selected"),
      optionsHook: useCityOptions,
    },
    {
      name: "category",
      type: "input",
      label: t("dealers.category"),
    },
  ];

  const yesNoOptions = [
    { value: "1", label: t("common.yes") },
    { value: "0", label: t("common.no") },
  ];

  const thirdRow: FilterField[] = [
    {
      name: "Main",
      type: "select",
      label: t("dealers.Main"),
      placeholder: t("common.not_selected"),
      options: yesNoOptions,
    },
    {
      name: "extendedForNextYear",
      type: "select",
      label: t("dealers.extendedForNextYear"),
      placeholder: t("common.not_selected"),
      options: yesNoOptions,
    },
  ];

  // Принудительные переносы: вторая и третья строки всегда начинаются
  // с новой строки грида (раскладка 5 / 5 / 2, как в старой форме).
  secondRow[0] = { ...secondRow[0], newRow: true };
  thirdRow[0] = { ...thirdRow[0], newRow: true };

  return [...firstRow, ...secondRow, ...thirdRow];
};
